import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddOnboardingDetailsComponent } from './onboarding/add-onboarding-details/add-onboarding-details.component';
import { AuthenticationGuard } from 'microsoft-adal-angular6';
import { EmployeeListComponent } from './onboarding/employee-list/employee-list.component';
import { EmployeeProfilesListComponent } from './employee-profiles-list/employee-profiles-list.component';

import { EmployeeVerificationComponent } from './onboarding/employee-verification/employee-verification.component';

import { HREmployeeListComponent } from './hr/employee-list/hr-employee-list.component';
import { HrEmployeeDetailsComponent } from './hr/hr-employee-details/hr-employee-details.component';
import { HrHistoryComponent } from './hr/hr-history/hr-history.component';
import { CanActivateGuard } from './can-activate.guard';
import { NotAuthorizedComponent } from './not-authorized/not-authorized.component';
import { EmployeeInsuranceComponent } from './insurance/employee-insurance/employee-insurance.component';
import { HrPermissionListComponent } from './hr/hr-permission-list/hr-permission-list.component';
import { HrAddPermissionComponent } from './hr/hr-add-permission/hr-add-permission.component';
// import { SubmissionComponent } from './onboarding/submission/submission.component';
import { EmployeeWithoutPermissionComponent } from './hr/employee-without-permission/employee-without-permission.component';
import { DefaultComponent } from './default/default.component';
import { combineAll } from 'rxjs/Operators';
import { EmployeeInsuranceListComponent } from './insurance/Insurance-list/employee-insurance-list';
import { SetInsuranceOptionsComponent } from './insurance/set-insurance-options/set-insurance-options.component';
import { OffboardingEmployeeListComponent } from './offboarding/offboarding-employee-list/offboarding-employee-list.component';
import { AddOffboardingDetailsComponent } from './offboarding/add-offboarding-details/add-offboarding-details.component';
import { OffboardingFeedbackComponent } from './offboarding/offboarding-feedback/offboarding-feedback.component';
import { OffboardingSettingsComponent } from './offboarding/offboarding-settings/offboarding-settings.component';
import { SumAssuredListPopupComponent } from './shared/components/sum-assured-list-popup/sum-assured-list-popup.component';
import { HrMonthClosureComponent } from './hr/hr-monthclosure/hr-month-closure.component';
import { HrNominationComponent } from './awards/hr-nomination/hr-nomination.component';
import { ExitInterviewFormComponent } from "./offboarding/exit-interview-form/exit-interview-form.component";
import { HRHolidaysLsitComponent } from "./hr/hr-holidays-list/hr-holidays-list.component";
import { HRHolidaysDetailsComponent } from "./hr/hr-holidays-details/hr-holidays-details.component";
import { ProfileComponent } from './hr/profile-ms-teams/profile-ms-teams.component';

const routes: Routes = [
  { path: '', component: DefaultComponent, pathMatch: 'full' },
  { path: 'myprofile/:empCode', component: HrEmployeeDetailsComponent, canActivate: [CanActivateGuard], pathMatch: 'full' },
  { path: 'mail/:empCode_ID', component: ProfileComponent, canActivate: [CanActivateGuard], pathMatch: 'full' },
  { path: 'not-authorized', component: NotAuthorizedComponent },
  { path: 'Insurance', component: EmployeeInsuranceComponent, canActivate: [CanActivateGuard] },
  { path: 'EmployeeWithoutPermission', component: EmployeeWithoutPermissionComponent },
  { path: 'EmpnsuranceList', component: EmployeeInsuranceListComponent, canActivate: [CanActivateGuard], pathMatch: 'full' },
  { path: 'SetInsuranceOptions', component: SetInsuranceOptionsComponent, canActivate: [CanActivateGuard] },
   { path: 'sumAssuredDetails', component: SumAssuredListPopupComponent, canActivate: [CanActivateGuard], pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

